export default __webpack_public_path__ + "static/media/hospmng.8125d75f.png";